const fees = {
  totalFeesCollected: 1000005, 
  totalFeesToCollect: 1044444,
};

export default  fees;

    